import { render, staticRenderFns } from "./add.vue?vue&type=template&id=a506332a&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=a506332a&prod&scoped=true&lang=css"
import style1 from "./add.vue?vue&type=style&index=1&id=a506332a&prod&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a506332a",
  null
  
)

export default component.exports